import React, { Component } from 'react';
import axios from 'axios';
import { Alert } from 'reactstrap';

import ContactForm from './ContactForm/ContactForm';

class ContactFormContainer extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      submitted: false,
      errors: [],
    };
  }

  handleSubmit(values, cb) {
    const fields = Object.entries(values).map(([k, v]) => {
      return {
        name: k,
        value: v
      }
    })
    if (typeof window !== "undefined" && window.previousPath) {
      fields.push({name: "webformmetadata", value: window.previousPath})
    }

    let data = {
      fields,
      legalConsentOptions: {
        consent: {
          // Include this object when GDPR options are enabled
          consentToProcess: true,
          text:
              'I agree to allow Cloudnexa, Inc. to store and process my personal data.',
        },
      },
      context: {
        pageName: 'Contact us',
        pageUri: window.location.href,
      },
    };

    axios
      .post(`${process.env.GATSBY_HUBSPOT_FORM_URL}`, data)
      .then((response) => {
          this.setState({ submitted: true });
      }).catch((error) => {
        // console.log("Error:", error.response)
        const errorMessages = [error.response.data.message].concat(error.response.data.errors.map(e => e.message))
        this.setState({ submitted: true, errors: errorMessages });
      });
    cb(false);
  }

  render() {
    const { submitted, errors } = this.state;

    if (submitted && !errors.length)
      return <Alert color="success">Your message was successfully sent.</Alert>;

    return (
        <>
          {errors.length > 0 && <Alert color="danger">
            {errors.map(e => <p>{e}</p>)}
          </Alert>}
          <ContactForm onSubmit={this.handleSubmit} />
        </>
    )
  }
}

export default ContactFormContainer;
